import React, { useState } from 'react'
import InputTextWithSwitch from './InputTextWithSwitch';
import GradientButton from '../Button/GradientButton';



const ReferTalentOrSME = () => {
    const [items, setItems] = useState([
        { id: 1, title: 'Allow Certifications', selected: true, },
        { id: 2, title: 'Allow Educational Experience', selected: true, },
        { id: 3, title: 'Allow Work Experience', selected: true, },
        { id: 4, title: 'Allow Personal Information', selected: true, },
        { id: 5, title: 'Allow Portfolio Links', selected: true, },
    ])

    const handleChange = (id, value) => {
        const updatedItems = items.map(item => {
            if(item.id === id){
                return { ...item, selected: value };
            }
            return item;
        })
        console.log(updatedItems, " = Privacy Management");
        setItems(updatedItems);
    }

  return (
    <div className='bg-pureWhite rounded-[16px] px-3 py-5 flex flex-col gap-y-4'>
      <p className="text-lg font-medium">Refer Special Talent or SME</p>
      <p className="text-base text-[#8F8F8F]">Do you happened to know a special talent or SME you would like to refer to join M3 ? </p>
      <GradientButton>Refer Someone</GradientButton>
    </div>
  );
}

export default ReferTalentOrSME
